function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.833 6.417a1.833 1.833 0 11-3.666 0 1.833 1.833 0 013.666 0zm-5.5 0a3.667 3.667 0 107.334 0 3.667 3.667 0 00-7.334 0zM11 11c-5.513 0-7.333 2.063-7.333 6.188 0 1.375.61 2.062 1.833 2.062h8.028a4.125 4.125 0 103.495-6.416C15.908 11.61 14 11 11 11zm3.817 2.432c-.85-.424-2.08-.599-3.817-.599-4.306 0-5.5 1.076-5.5 4.354 0 .1.003.176.006.23h7.352a4.123 4.123 0 011.958-3.985zm2.6 3.068h1.833v.917h-1.833v1.833H16.5v-1.833h-1.833V16.5H16.5v-1.833h.917V16.5z"
});

var SvgUserPlus = function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22"
  }), _ref);
};

export default SvgUserPlus;